import { render, staticRenderFns } from "./Fundotercoper.vue?vue&type=template&id=f1d399dc&"
import script from "./Fundotercoper.vue?vue&type=script&lang=js&"
export * from "./Fundotercoper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports